/*https://github.com/harttle/liquidjs/wiki*/

import Liquid from 'liquidjs';
// import { add_attribute } from 'svelte/internal';
import { getIndexByAttr } from './ListExtensions';

let engine = new Liquid.Liquid();
engine.registerFilter('ing', v => v + 'ing');


export async function getBenefitsList(data, product) {
    return new Promise((resolve, reject) => {

        if (data.features.length < 1)
            reject('First Feature has no value -> no benefit generation');

        let templates = {
            basedOnGains: [
                "{{gain}}? Possible thanks to {{feature}} by {{product}}.",
                "{{gain}}? Try {{product}}'s {{feature}}.",
                "{{gain}}? {{feature}} will get you there.",
                "{{feature}} to finally realize {{gain|ing}}.",
                "{{feature}}. Say hello to {{gain}}.",
                "A new way to {{gain}}: {{feature}} by {{product}}.",
                "The secret to {{gain}}: {{feature}}.",
                "Start {{gain|ing}}, thanks to {{feature}}.",
                "{{gain}}? Possible thanks to {{feature}} by {{product}}.",
                "Finally {{gain}} without **{{pain}}**: {{feature}}."
            ],
            basedOnPains: [
                "{{pain|ing}}? Not any more with {{feature}} by {{product}}.",
                "{{pain|ing}}? Try {{product}}'s {{feature}}.",
                "{{pain|ing}}? {{feature}} will set an end to it.",
                "{{feature}} by {{product}}: Finally stop {{pain|ing}}.",
                "{{feature}}. Forget {{pain|ing}}.",
                "Tired of {{pain|ing}}? Meet {{feature}} by {{product}}.",
                "No more {{pain|ing}}. Welcome {{feature}}.",
                "No more {{pain|ing}}. Say hello to {{feature}}.",
                "Stop {{pain|ing}} once and for all: {{feature}} by {{product}}.",
                "Struggling with {{pain}}? Try {{feature}}."
            ],
            basedOnJobs: [
                "{{job}}. Get it done with {{feature}}.",
                "{{job}}. Now easier with {{feature}}.",
                "{{job}} made easy: {{feature} by {{product}}.",
                "{{feature}}: {{job}} in a breeze.",
                "{{feature}}: {{job}}, made easy.",
                "A better way to {{job}}: {{feature}} by {{product}}.",
                "{{job}} with the hassle: {{feature}}.",
                "Make {{job}} fun again: {{feature}} by {{product}}."
            ]

        }
        const mode = {
            painOnly: 0,
            gainOnly: 1,
            jobOnly: 2,
            painGain: 3,
            painJob: 4,
            gainJob: 5,
            painGainJob: 6
        };

        let currentMode = null;
        let scope = { product: product.name, feature: data.features[0].text }; //{gain: data.gains[0].text, pain: data.pains[0].text, feature: data.features[0].text, product: product.name};

        if (data.pains.length > 0) {
            currentMode = mode.painOnly;
            scope['pain'] = data.pains[0].text;
        }
        if (data.gains.length > 0) {
            currentMode = currentMode == mode.painOnly ? currentMode = mode.painGain : currentMode = mode.gainOnly;
            scope['gain'] = data.gains[0].text;
        }
        if (data.jobs.length > 0) {
            if (currentMode == mode.painGain)
                currentMode = mode.painGainJob;
            else if (currentMode == mode.painOnly)
                currentMode = mode.painJob;
            else if (currentMode == mode.gainOnly)
                currentMode = mode.gainJob;
            else currentMode = mode.jobOnly;

            scope['job'] = data.jobs[0].text;
        }

        //  for(var i = 0; data.pains.length > i; i++){
        //      if(data.pains[i].text != null){
        //          currentMode = mode.painOnly
        //          break;
        //      }
        //  } 
        //  for(var i = 0; data.gains.length > i; i++){
        //     if(data.gains[i].text != null){
        //         if(currentMode = mode.painOnly)
        //             currentMode = mode.painGain;
        //         else currentMode = mode.gainOnly;    
        //         break;
        //     }
        // } 
        // for(var i = 0; data.jobs.length > i; i++){
        //     if(data.jobs[i].text != null){
        //         if(currentMode = mode.painGain)
        //             currentMode = mode.painGainJob;
        //         else if (currentMode = mode.painOnly)
        //             currentMode = mode.painJob;    
        //         else if (currentMode = mode.gainOnly)
        //             currentMode = mode.gainJob;
        //         else currentMode = mode.jobOnly;      
        //         break;
        //     }
        // } 

        if (currentMode == null)
            reject('Could not set mode for getBenefitsList');

        let useTemplate = []; //templates.basedOnGains;

        switch (currentMode) {
            case mode.painOnly:
                useTemplate = templates.basedOnPains;
                break;
            case mode.gainOnly:
                useTemplate = templates.basedOnGains;
                break;
            case mode.jobOnly:
                useTemplate = templates.basedOnJobs;
                break;
            case mode.painGain:
                for (let x = 0; x < 5; x++) {
                    let g = getRandomItem(templates.basedOnGains);
                    useTemplate.push(g.entry);
                    templates.basedOnGains.splice(g.index, 0);

                    let p = getRandomItem(templates.basedOnPains);
                    useTemplate.push(p.entry);
                    templates.basedOnPains.splice(p.index, 0);

                }
                break;
            case mode.painJob:
                for (let x = 0; x < 5; x++) {
                    let j = getRandomItem(templates.basedOnJobs);
                    useTemplate.push(j.entry);
                    templates.basedOnJobs.splice(j.index, 0);

                    let p = getRandomItem(templates.basedOnPains);
                    useTemplate.push(p.entry);
                    templates.basedOnPains.splice(p.index, 0);

                }
                break;
            case mode.gainJob:
                for (let x = 0; x < 5; x++) {
                    let j = getRandomItem(templates.basedOnJobs);
                    useTemplate.push(j.entry);
                    templates.basedOnJobs.splice(j.index, 0);

                    let g = getRandomItem(templates.basedOnGains);
                    useTemplate.push(g.entry);
                    templates.basedOnGains.splice(g.index, 0);
                }
                break;
            case mode.painGainJob:
                for (let x = 0; x < 4; x++) {
                    let j = getRandomItem(templates.basedOnJobs);
                    useTemplate.push(j.entry);
                    templates.basedOnJobs.splice(j.index, 0);

                    let g = getRandomItem(templates.basedOnGains);
                    useTemplate.push(g.entry);
                    templates.basedOnGains.splice(g.index, 0);

                    let p = getRandomItem(templates.basedOnPains);
                    useTemplate.push(p.entry);
                    templates.basedOnPains.splice(p.index, 0);
                }
                break;
        }

        if (useTemplate.length < 1)
            reject('Could not set mode for ${currentMode}');

        let rVal = []

        for (let i = 0; useTemplate.length > i; i++) {
            let term = useTemplate[i];
            engine.parseAndRender(term, scope)
                .then((res) => { rVal.push({ text: res, value: i }) });
        }
        resolve(rVal);

    });
}


function getRandomItem(arr) {
    let entry = arr[Math.floor(Math.random() * arr.length)];
    let index = getIndexByAttr(arr, 'value', entry.value)
    return { entry: entry, index: index };
}

export const templateDemo = async function (model, type) {

    const css = await engine.renderFile(getCSSUrl(type));
    model = `<style>${css}</style>${model}`;
    const baseCSS = await engine.renderFile(`/templates/css/base.css`);
    model = `<style>${baseCSS}</style>${model}`;

    const tagDef = {
        parse: function (tagToken, remainTokens) {
            // const props = tagToken.args.replace(/\s+/g, '');
            const props = tagToken.args.replace(' ', '');

            const propsData = props.split(/,(.*)/);
            this.componentName = propsData[0];
            eval('this.data=' + propsData[1]);
        },
        render: async function (scope, hash) {
            if (this.data == null)
                this.data = scope.environments;
            console.log(this.componentName)
            console.log(this.data)
            const path = await getTemplateUrl(this.componentName, type);
            return await engine.renderFile(path, this.data);
        }
    };
    engine.registerTag('comp', tagDef);
    engine.registerTag('layout', tagDef);

    return new Promise((resolve, reject) => {
        const scope = { headline: 'Default Headline' };
        engine.parseAndRender(model, scope)
            .then((res) => { resolve(res) }).catch((e) => { reject(e) });
    });
}

async function getTemplateUrl(compName, type) {
    let rVal = null;
    switch (compName) {
        case 'hero': rVal = await getUrl('/templates/layouts/hero', type); break;
        case 'row': rVal = await getUrl('/templates/layouts/row', type); break;
        case 'header': rVal = '/templates/components/header.html'; break;
        case 'cell': rVal = '/templates/components/cell.html'; break;

    }
    console.log(rVal);
    return rVal;
}

function getCSSUrl(type) {
    // let rVal = null;
    // switch (type) {
    //     case 0: rVal = '/templates/css/design_1.css'; break;
    //     case 1: rVal = '/templates/css/design_2.css'; break;
    // }
    // console.log(type);
    // return rVal;
    return `/templates/css/design_${type + 1}.css`;
}

async function getUrl(path, type){
    const directPath = `${path}/design_${type + 1}.html`;
    const defaultPath = `${path}/index.html`;

    // const fileExist = await doesFileExist(directPath);
    // if(fileExist) return directPath
    // return `${path}/index.html`
    let rVal = defaultPath;
    switch (type) {
        case 0: rVal = defaultPath; break;
        case 1: rVal = directPath; break;
    }
    return rVal;
}

async function doesFileExist(urlToFile) {
    var xhr = new XMLHttpRequest();
    xhr.open('HEAD', urlToFile, false);
    xhr.send();
     console.log(xhr)
    if (xhr.status == "404") {
        return false;
    } else {
        return true;
    }
}